import api from './api';
import type { GeoJSONFeatureCollection } from '../types/gis';

/** Hydrate an ephemeral FeatureCollection that a GIS tool parked in Redis
 *  when its result exceeded the inline LLM-context cap (>20 features).
 *  TTL is 5 minutes on the writer side; throws on 404. */
export async function getEphemeralGeojson(
  ephemeralId: string,
): Promise<GeoJSONFeatureCollection> {
  const response = await api.get(`/maps/ephemeral/${encodeURIComponent(ephemeralId)}`);
  return response.data?.geojson as GeoJSONFeatureCollection;
}
